export function getScrollTop(el?: Element): number {
  return el ? el.scrollTop : document.documentElement.scrollTop || document.body.scrollTop;
}

export function getContentHeight(el?: Element): number {
  return el ? el.scrollHeight : document.documentElement.scrollHeight;
}

export function shouldLoadMore(el: Element, contentHeight: number, viewHeight: number, threshold = 500): boolean {
  const distanceToBottom = contentHeight - getScrollTop(el) - viewHeight;
  return distanceToBottom > threshold ? false : true;
}
